import { computed } from 'vue';
import { Shortcut } from '@/types/shortcut';
import store from '@/store';

export default class CountryManagementComponent {
	public removalShortcuts = computed((): Shortcut[] => {
		return store.getters.removalShortcuts();
	});
}
